import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { DEBUG } from "../env";
import Package from "../package.json";
import Api from "./js/Api";
import SocketConnection from "./js/Socket";
import VueMasonry from "vue-masonry-css";
import VueConfetti from "vue-confetti";

//eslint-disable-next-line no-unused-vars
import { VueReCaptcha } from "vue-recaptcha-v3";

import "/src/css/style.css";

console.log("Version", Package.version);

const API = new Api();
Vue.config.productionTip = false;
Vue.prototype.$DEBUG = DEBUG;
Vue.prototype.$API = API;
Vue.prototype.$SOCKET = SocketConnection;
Vue.use(VueMasonry);
Vue.use(VueConfetti);
if (window.location.pathname.toString().indexOf("circuito/inscripcion") == -1) {
  Vue.use(VueReCaptcha, {
    siteKey: "6Le8XlQeAAAAAKmlamDJVakF1iE_CGmyAqXyd57x"
  });
}

router.beforeEach((to, from, next) => {
  // eslint-disable-next-line
  gtag("config", "G-GJL9TMF6FH", {
    page_path: to.fullPath,
    page_title: document.title + "" - "" + to.path
  });
  next();
});

// Vue.config.errorHandler = function (err, vm, info) {
//   console.log("error",err, vm, info)
// }

new Vue({
  router,
  store,
  vuetify,

  render: h => h(App)
}).$mount("#app");
